import React from "react";
import { Link } from "react-router-dom";
import "../../assets/scss/generic/edButton.scss";

export interface IBtnProps {
	value: string | React.ReactElement;
	// value - display text of the button, react components can also be passed if required
	type?: "button" | "submit" | "reset"; // the three types of button
	btnTyp: "primary" | "secondary" | "link" | "blue-link"; // color of the button
	slim?: boolean; // pass this prop if button is slim
	disabled?: boolean; // if disabled then pass true
	className?: string; // optional className if additional CSS needs to be provided
}
export interface IEdButtonProps extends IBtnProps {
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick,
	"aria-label"?: string;
}

interface IEdLinkButtonProps extends IBtnProps {
	LinkHref: string;
}

const EdButton: React.FC<IEdButtonProps> = (props: IEdButtonProps) => {
	// Checks if button or action
	const btnOrActionClass = props.btnTyp === "primary" || props.btnTyp === "secondary" ? "button" : "action";

	return (
		<button
			type={props.type}
			className={`ed_button ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${
				props.className ? ` ${props.className}` : ""
			}`}
			onClick={props.onClick}
			disabled={props.disabled}
			aria-disabled={props.disabled}
			aria-label={props["aria-label"]}
		>
			{props.value}
		</button>
	);
};

export const EdLinkButton: React.FC<IEdLinkButtonProps> = (props: IEdLinkButtonProps) => {
	// Checks if button or action
	const btnOrActionClass = props.btnTyp === "primary" || props.btnTyp === "secondary" ? "button" : "action";

	return (
		<Link
			to={props.LinkHref}
			type={props.type}
			className={`ed_button ib  ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${
				props.className ? ` ${props.className}` : ""
			}`}
		>
			{props.value}
		</Link>
	);
};

export const EdALinkButton: React.FC<IEdLinkButtonProps> = (props: IEdLinkButtonProps) => {
	// Checks if button or action
	const btnOrActionClass = props.btnTyp === "primary" || props.btnTyp === "secondary" ? "button" : "action";

	return (
		<a
			target="_blank"
			rel="noopener noreferrer"
			href={props.LinkHref}
			type={props.type}
			className={`ed_button ib ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${
				props.className ? ` ${props.className}` : ""
			}`}
		>
			{props.value}
		</a>
	);
};

export default EdButton;
